import React, { useState } from 'react';
import { FileUploadList } from './FileUploadList';
import { FileUploadErrorBanner } from './FileUploadErrorBanner';
import { StyledUploadModalContent, StyledFailedFilesCountText } from './styles';
import { getFailedUploadCount, getFileUploadProgress, getIsDoneCount, getSuccessfulUploadCount, isAllDone } from './services';
import { FileUploadHeader } from './FileUploadHeader';
import { Modal } from "../modal";
import { BannerStyle } from "../banner";
import { ButtonStyle } from "../button";
import { ProgressBar, ProgressBarColor, ProgressBarHeight } from "../progress-bar";
export const FileUploadModal = ({ files, isOpen, errorMessages, shouldShowCompleted = false, handleShowCompletedChange, shouldShowFailedCountOnHeader, canceledUploadCount = 0, translateFn = (key) => key, doneButtonId = 'file-upload-done-button', fileUploadModalId = 'file-upload-modal', retryAllButtonId = 'retry-all-button', exitAnywayButtonId = 'exit-anyway-button', reuploadButtonId = 'reupload-button', onReupload, onClose, onCancel, onRetryAll, showRetryAll, onRetry, maxVideoFileSize, isBusy, shouldHideThumbnail, progressBarColor, shouldHideCompletedCheckbox, shouldShowHeaderCloseButton, shouldShowCompletedProgress, isEnhancedPhotoCaptureEnabled = false }) => {
    const [showCompleted, toggleShowCompleted] = useState(shouldShowCompleted);
    const isDoneCount = getIsDoneCount(files);
    const successCount = getSuccessfulUploadCount(files);
    const progressPercentage = getFileUploadProgress(successCount, files.length);
    const errorBanner = errorMessages && errorMessages.length > 0 ? (React.createElement(FileUploadErrorBanner, { errorMessages: errorMessages, errorCount: getFailedUploadCount(files), bannerStyle: BannerStyle.ALERT, translateFn: translateFn, maxVideoFileSize: maxVideoFileSize })) : null;
    const onShowCompletedChange = () => {
        toggleShowCompleted(!showCompleted);
        if (handleShowCompletedChange) {
            handleShowCompletedChange(!showCompleted);
        }
    };
    const canceledText = canceledUploadCount > 0 ? ` ${canceledUploadCount} ${translateFn('Canceled')}` : '';
    const getSubtitle = () => {
        if (shouldShowFailedCountOnHeader && getFailedUploadCount(files) > 0)
            return (React.createElement(React.Fragment, null,
                getSuccessfulUploadCount(files),
                " ",
                translateFn('Completed'),
                ' ',
                React.createElement(StyledFailedFilesCountText, null,
                    "(",
                    getFailedUploadCount(files),
                    " ",
                    translateFn('Failed'),
                    ")"),
                ' ',
                canceledText));
        else
            return `${getSuccessfulUploadCount(files)} ${translateFn('Completed')}${canceledText}`;
    };
    const headerComponent = (React.createElement(FileUploadHeader, { onShowCompletedChange: () => onShowCompletedChange(), shouldHideCompletedCheckbox: shouldHideCompletedCheckbox, title: isDoneCount === files.length
            ? translateFn('Upload Complete')
            : translateFn('Uploading attachments...'), subtitle: getSubtitle(), showCompleted: showCompleted, switchLabel: translateFn('Show Completed') }));
    const handleOnRetryAll = () => {
        if (onRetryAll) {
            onRetryAll();
        }
    };
    const retryAllButtonProps = {
        label: translateFn('Retry All'),
        style: ButtonStyle.Primary,
        disabled: false,
        isHoverEffectDisabled: false,
        onClick: handleOnRetryAll,
        id: retryAllButtonId
    };
    const exitAnywaysButtonProps = {
        label: translateFn('Exit Anyway'),
        style: ButtonStyle.Secondary,
        disabled: false,
        isHoverEffectDisabled: false,
        onClick: onClose,
        id: exitAnywayButtonId
    };
    const reuploadButton = {
        label: translateFn('Reupload'),
        id: reuploadButtonId,
        isBusy: isBusy,
        icon: 'mi-icon-upload3',
        //primary is blue, tertiary is light grey
        style: ButtonStyle.Primary,
        //TODO: Functionality of onReupload will allow users to upload additional photos/videos/attachments after the initial upload.
        onClick: onReupload,
        disabled: !(isOpen && isAllDone(files))
    };
    const doneButton = {
        label: translateFn('Done'),
        id: doneButtonId,
        isBusy: isBusy,
        //tertiary is light grey
        style: isEnhancedPhotoCaptureEnabled ? ButtonStyle.Tertiary : ButtonStyle.Primary,
        onClick: onClose,
        disabled: !(isOpen && isAllDone(files))
    };
    const modalProps = Object.assign(Object.assign({ id: fileUploadModalId, isOpen: isOpen, maxWidth: 'lg', hideClose: !shouldShowHeaderCloseButton, minHeight: 200, onClose: onClose, title: headerComponent }, (isEnhancedPhotoCaptureEnabled
        ? {
            //primary button is either reupload or retry all. REPLACE DONE BUTTON WITH REUPLOAD
            primaryBtn: showRetryAll ? retryAllButtonProps : reuploadButton,
            //secondary button is the reupload button if retry all is shown. REPLACE EXIT ANYWAYS WITH REUPLOAD
            secondaryBtn: showRetryAll ? reuploadButton : undefined,
            //tertiary button is always the done (close) button
            tertiaryBtn: Object.assign(Object.assign({}, doneButton), { label: translateFn('Close') })
        }
        : {
            //without enhancedphotocapture behavior is not modified
            primaryBtn: showRetryAll ? retryAllButtonProps : doneButton,
            secondaryBtn: showRetryAll ? exitAnywaysButtonProps : undefined
        })), { maxHeight: true });
    const progress = progressPercentage !== 100 || shouldShowCompletedProgress ? (React.createElement(ProgressBar, { color: progressBarColor || ProgressBarColor.GREEN, height: ProgressBarHeight.SMALL, progress: progressPercentage })) : null;
    const uploadModal = (React.createElement(Modal, Object.assign({}, modalProps),
        React.createElement(StyledUploadModalContent, null,
            progress,
            errorBanner,
            React.createElement(FileUploadList, { files: files, shouldHideThumbnail: shouldHideThumbnail, shouldShowCompleted: showCompleted, progressBarColor: progressBarColor, translateFn: translateFn, onCancel: onCancel, onRetry: onRetry }))));
    return isOpen ? uploadModal : React.createElement(React.Fragment, null);
};
//# sourceMappingURL=FileUploadModal.js.map